import { render, staticRenderFns } from "./CampusUserNetworkZones.vue?vue&type=template&id=f8802e54&scoped=true&"
import script from "./CampusUserNetworkZones.vue?vue&type=script&lang=ts&"
export * from "./CampusUserNetworkZones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8802e54",
  null
  
)

export default component.exports